import { QueryClient } from '@tanstack/react-query';

const queryClient: QueryClient = new QueryClient({});

export default queryClient;
